import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../../../components/LogoWhite";
import Modal from "../../../../components/Modal";
import ContentFormCompany from "./contentFormCompany";
import { signOut } from "firebase/auth";
import { auth } from "../../../../FirebaseConfig.ts";

const itemsEmployee = [
  {
    name: "Escritorio",
    href: "/consultar",
    icon: (
      <svg width="24" height="24" viewBox="0 -0.5 25 25" fill="none">
        <path
          d="M6.25 10.5C6.25 10.0858 5.91421 9.75 5.5 9.75C5.08579 9.75 4.75 10.0858 4.75 10.5H6.25ZM11.5 19.75C11.9142 19.75 12.25 19.4142 12.25 19C12.25 18.5858 11.9142 18.25 11.5 18.25V19.75ZM4.75 10.5C4.75 10.9142 5.08579 11.25 5.5 11.25C5.91421 11.25 6.25 10.9142 6.25 10.5H4.75ZM11.5 5.75C11.9142 5.75 12.25 5.41421 12.25 5C12.25 4.58579 11.9142 4.25 11.5 4.25V5.75ZM5.5 9.75C5.08579 9.75 4.75 10.0858 4.75 10.5C4.75 10.9142 5.08579 11.25 5.5 11.25V9.75ZM11.5 11.25C11.9142 11.25 12.25 10.9142 12.25 10.5C12.25 10.0858 11.9142 9.75 11.5 9.75V11.25ZM10.75 10.5C10.75 10.9142 11.0858 11.25 11.5 11.25C11.9142 11.25 12.25 10.9142 12.25 10.5H10.75ZM12.25 5C12.25 4.58579 11.9142 4.25 11.5 4.25C11.0858 4.25 10.75 4.58579 10.75 5H12.25ZM12.25 10.5C12.25 10.0858 11.9142 9.75 11.5 9.75C11.0858 9.75 10.75 10.0858 10.75 10.5H12.25ZM10.75 14C10.75 14.4142 11.0858 14.75 11.5 14.75C11.9142 14.75 12.25 14.4142 12.25 14H10.75ZM11.5 18.25C11.0858 18.25 10.75 18.5858 10.75 19C10.75 19.4142 11.0858 19.75 11.5 19.75V18.25ZM20.25 14C20.25 13.5858 19.9142 13.25 19.5 13.25C19.0858 13.25 18.75 13.5858 18.75 14H20.25ZM10.75 19C10.75 19.4142 11.0858 19.75 11.5 19.75C11.9142 19.75 12.25 19.4142 12.25 19H10.75ZM12.25 14C12.25 13.5858 11.9142 13.25 11.5 13.25C11.0858 13.25 10.75 13.5858 10.75 14H12.25ZM11.5 4.25C11.0858 4.25 10.75 4.58579 10.75 5C10.75 5.41421 11.0858 5.75 11.5 5.75V4.25ZM18.75 14C18.75 14.4142 19.0858 14.75 19.5 14.75C19.9142 14.75 20.25 14.4142 20.25 14H18.75ZM19.5 14.75C19.9142 14.75 20.25 14.4142 20.25 14C20.25 13.5858 19.9142 13.25 19.5 13.25V14.75ZM11.5 13.25C11.0858 13.25 10.75 13.5858 10.75 14C10.75 14.4142 11.0858 14.75 11.5 14.75V13.25ZM4.75 10.5L4.75 15H6.25L6.25 10.5H4.75ZM4.75 15C4.75 17.6234 6.87665 19.75 9.5 19.75V18.25C7.70507 18.25 6.25 16.7949 6.25 15H4.75ZM9.5 19.75H11.5V18.25H9.5V19.75ZM6.25 10.5V9H4.75V10.5H6.25ZM6.25 9C6.25 7.20507 7.70507 5.75 9.5 5.75V4.25C6.87665 4.25 4.75 6.37665 4.75 9H6.25ZM9.5 5.75H11.5V4.25H9.5V5.75ZM5.5 11.25H11.5V9.75H5.5V11.25ZM12.25 10.5V5H10.75V10.5H12.25ZM10.75 10.5V14H12.25V10.5H10.75ZM11.5 19.75H15.5V18.25H11.5V19.75ZM15.5 19.75C18.1234 19.75 20.25 17.6234 20.25 15H18.75C18.75 16.7949 17.2949 18.25 15.5 18.25V19.75ZM20.25 15V14H18.75V15H20.25ZM12.25 19V14H10.75V19H12.25ZM11.5 5.75H15.5L15.5 4.25H11.5V5.75ZM15.5 5.75C17.2949 5.75 18.75 7.20507 18.75 9L20.25 9C20.25 6.37665 18.1234 4.25 15.5 4.25L15.5 5.75ZM18.75 9V14H20.25V9L18.75 9ZM19.5 13.25H11.5V14.75H19.5V13.25Z"
          className="fill-current"
        />
      </svg>
    ),
  },
];

const menuItems = [
  {
    name: "Solicitudes Pendientes",
    href: "/plataforma",
    icon: (
      <svg width="24" height="24" viewBox="0 -0.5 25 25" fill="none">
        <path
          d="M6.25 10.5C6.25 10.0858 5.91421 9.75 5.5 9.75C5.08579 9.75 4.75 10.0858 4.75 10.5H6.25ZM11.5 19.75C11.9142 19.75 12.25 19.4142 12.25 19C12.25 18.5858 11.9142 18.25 11.5 18.25V19.75ZM4.75 10.5C4.75 10.9142 5.08579 11.25 5.5 11.25C5.91421 11.25 6.25 10.9142 6.25 10.5H4.75ZM11.5 5.75C11.9142 5.75 12.25 5.41421 12.25 5C12.25 4.58579 11.9142 4.25 11.5 4.25V5.75ZM5.5 9.75C5.08579 9.75 4.75 10.0858 4.75 10.5C4.75 10.9142 5.08579 11.25 5.5 11.25V9.75ZM11.5 11.25C11.9142 11.25 12.25 10.9142 12.25 10.5C12.25 10.0858 11.9142 9.75 11.5 9.75V11.25ZM10.75 10.5C10.75 10.9142 11.0858 11.25 11.5 11.25C11.9142 11.25 12.25 10.9142 12.25 10.5H10.75ZM12.25 5C12.25 4.58579 11.9142 4.25 11.5 4.25C11.0858 4.25 10.75 4.58579 10.75 5H12.25ZM12.25 10.5C12.25 10.0858 11.9142 9.75 11.5 9.75C11.0858 9.75 10.75 10.0858 10.75 10.5H12.25ZM10.75 14C10.75 14.4142 11.0858 14.75 11.5 14.75C11.9142 14.75 12.25 14.4142 12.25 14H10.75ZM11.5 18.25C11.0858 18.25 10.75 18.5858 10.75 19C10.75 19.4142 11.0858 19.75 11.5 19.75V18.25ZM20.25 14C20.25 13.5858 19.9142 13.25 19.5 13.25C19.0858 13.25 18.75 13.5858 18.75 14H20.25ZM10.75 19C10.75 19.4142 11.0858 19.75 11.5 19.75C11.9142 19.75 12.25 19.4142 12.25 19H10.75ZM12.25 14C12.25 13.5858 11.9142 13.25 11.5 13.25C11.0858 13.25 10.75 13.5858 10.75 14H12.25ZM11.5 4.25C11.0858 4.25 10.75 4.58579 10.75 5C10.75 5.41421 11.0858 5.75 11.5 5.75V4.25ZM18.75 14C18.75 14.4142 19.0858 14.75 19.5 14.75C19.9142 14.75 20.25 14.4142 20.25 14H18.75ZM19.5 14.75C19.9142 14.75 20.25 14.4142 20.25 14C20.25 13.5858 19.9142 13.25 19.5 13.25V14.75ZM11.5 13.25C11.0858 13.25 10.75 13.5858 10.75 14C10.75 14.4142 11.0858 14.75 11.5 14.75V13.25ZM4.75 10.5L4.75 15H6.25L6.25 10.5H4.75ZM4.75 15C4.75 17.6234 6.87665 19.75 9.5 19.75V18.25C7.70507 18.25 6.25 16.7949 6.25 15H4.75ZM9.5 19.75H11.5V18.25H9.5V19.75ZM6.25 10.5V9H4.75V10.5H6.25ZM6.25 9C6.25 7.20507 7.70507 5.75 9.5 5.75V4.25C6.87665 4.25 4.75 6.37665 4.75 9H6.25ZM9.5 5.75H11.5V4.25H9.5V5.75ZM5.5 11.25H11.5V9.75H5.5V11.25ZM12.25 10.5V5H10.75V10.5H12.25ZM10.75 10.5V14H12.25V10.5H10.75ZM11.5 19.75H15.5V18.25H11.5V19.75ZM15.5 19.75C18.1234 19.75 20.25 17.6234 20.25 15H18.75C18.75 16.7949 17.2949 18.25 15.5 18.25V19.75ZM20.25 15V14H18.75V15H20.25ZM12.25 19V14H10.75V19H12.25ZM11.5 5.75H15.5L15.5 4.25H11.5V5.75ZM15.5 5.75C17.2949 5.75 18.75 7.20507 18.75 9L20.25 9C20.25 6.37665 18.1234 4.25 15.5 4.25L15.5 5.75ZM18.75 9V14H20.25V9L18.75 9ZM19.5 13.25H11.5V14.75H19.5V13.25Z"
          className="fill-current"
        />
      </svg>
    ),
  },
  {
    name: "Créditos",
    href: "/plataforma/creditos",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M2 14C2 10.2288 2 8.34315 3.17157 7.17157C4.34315 6 6.22876 6 10 6H14C17.7712 6 19.6569 6 20.8284 7.17157C22 8.34315 22 10.2288 22 14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14Z"
          className="stroke-current"
          strokeWidth="1.5"
        />
        <path
          d="M16 6C16 4.11438 16 3.17157 15.4142 2.58579C14.8284 2 13.8856 2 12 2C10.1144 2 9.17157 2 8.58579 2.58579C8 3.17157 8 4.11438 8 6"
          className="stroke-current"
          strokeWidth="1.5"
        />
        <path
          d="M12 17.3333C13.1046 17.3333 14 16.5871 14 15.6667C14 14.7462 13.1046 14 12 14C10.8954 14 10 13.2538 10 12.3333C10 11.4129 10.8954 10.6667 12 10.6667M12 17.3333C10.8954 17.3333 10 16.5871 10 15.6667M12 17.3333V18M12 10V10.6667M12 10.6667C13.1046 10.6667 14 11.4129 14 12.3333"
          className="stroke-current"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
  },

  {
    name: "Simulador",
    href: "/plataforma/simulador",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M9 7H6a2 2 0 00-2 2v9a2 2 0 002 2h8a2 2 0 002-2v-3m2-13L10 9m6-6h-4m4 0v4"
          className="stroke-current"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Buscar Simulación",
    href: "/plataforma/buscar-simulacion",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M11 6C13.7614 6 16 8.23858 16 11M16.6588 16.6549L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
          className="stroke-current"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Tasa Actual",
    href: "/plataforma/tasa",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          className="stroke-current"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M9 2h6c5 0 7 2 7 7v6c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7M8.57 15.27l6.54-6.54"
        ></path>
        <path
          className="stroke-current"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8.98 10.37a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46M15.52 16.09a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46"
        ></path>
      </svg>
    ),
  },
];

const managementItems = [
  {
    name: "Crear Pagador",
    type: "button",
    onClick: "onCreatePagador", // Nombre de la función que se pasará como prop
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <circle
          cx="12"
          cy="12"
          r="10"
          className="stroke-current"
          strokeWidth="1.5"
        />
        <path
          className="stroke-current"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="M15 12h-3m0 0H9m3 0V9m0 3v3"
        />
      </svg>
    ),
  },
  {
    name: "Pagadores",
    type: "link",
    href: "/plataforma/lista-empresas",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1"
          className="stroke-current"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Deudor",
    type: "link",
    href: "/plataforma/deudor",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Inversionistas",
    type: "link",
    href: "/plataforma/lista-inversionistas",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2M9 7a4 4 0 108 0 4 4 0 00-8 0M22 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
          className="stroke-current"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Cerrar Sesión",
    type: "button",
    onClick: "onLogout", // Nombre de la función que se pasará como prop
    icon: (
      <svg
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="-ml-1"
      >
        <path
          d="M15 12L2 12M2 12L5.5 9M2 12L5.5 15"
          class="stroke-primary group-hover:stroke-white transition-colors duration-200"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
        <path
          d="M9.00195 7C9.01406 4.82497 9.11051 3.64706 9.87889 2.87868C10.7576 2 12.1718 2 15.0002 2L16.0002 2C18.8286 2 20.2429 2 21.1215 2.87868C22.0002 3.75736 22.0002 5.17157 22.0002 8L22.0002 16C22.0002 18.8284 22.0002 20.2426 21.1215 21.1213C20.3531 21.8897 19.1752 21.9862 17 21.9983M9.00195 17C9.01406 19.175 9.11051 20.3529 9.87889 21.1213C10.5202 21.7626 11.4467 21.9359 13 21.9827"
          class="stroke-primary group-hover:stroke-white transition-colors duration-200"
          stroke-width="1.5"
          stroke-linecap="round"
        ></path>
      </svg>
    ),
  },
];

function Sidebar({ children, user, employee }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeButton, setActiveButton] = useState("");
  const location = useLocation();
  const pathname = location.pathname;
  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const isActive = (href) => pathname === href;

  // Función para manejar clicks en elementos del menú
  const handleItemClick = (actionName, item) => {
    if (actionName === "onCreatePagador") {
      setActiveButton(item.name); // Marcar como activo temporalmente
      setShowModal(true);
    }

    if (actionName === "onLogout") {
      signOut(auth);
    }
  };

  const getThemeColors = () => {
    if (hostname === "creditos.sofia.com.co") {
      return {
        primary: "bg-gray-900",
        hover: "hover:bg-gray-800",
        text: "text-gray-900",
        hoverText: "group-hover:text-white",
        accent: "bg-gray-800",
      };
    }
    return {
      primary: "bg-[#49b0a8]",
      hover: "hover:bg-[#3a8a84]",
      text: "text-[#49b0a8]",
      hoverText: "group-hover:text-white",
      accent: "bg-[#3a8a84]",
    };
  };

  const theme = getThemeColors();

  return (
    <>
      <aside
        className={`fixed top-0 left-0 z-40 w-72 h-screen transition-all duration-500 ease-in-out transform ${
          isLoaded ? "translate-x-0" : "-translate-x-full"
        } shadow-2xl`}
        aria-label="Sidebar"
      >
        <div className="h-full flex flex-col bg-white relative overflow-hidden">
          {/* Decorative gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-white via-gray-50 to-gray-100 opacity-60"></div>

          {/* Header with logo */}
          <div className={`relative ${theme.primary} pb-10 pt-6 shadow-lg`}>
            <div className="absolute inset-0 bg-gradient-to-r from-black/10 to-transparent">
              <Link to="/plataforma">
                {hostname === "creditos.sofia.com.co" ? (
                  <img
                    src="https://sofia.com.co/logo.webp"
                    width={200}
                    className="relative top-2"
                  />
                ) : (
                  <Logo platform size={130} />
                )}
              </Link>
            </div>
          </div>

          {/* Navigation Menu */}
          <div className="flex-1 px-4 py-6 relative">
            {/* Main Navigation */}
            <div className="mb-8">
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4 px-3 text-left">
                Navegación Principal
              </h3>
              <nav className="space-y-2">
                {(employee ? itemsEmployee : menuItems).map((item, index) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`group flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-300 ease-in-out transform hover:scale-105 relative overflow-hidden ${
                      isActive(item.href)
                        ? `${theme.primary} text-white shadow-lg scale-105`
                        : `text-gray-700 ${theme.hover} hover:text-white hover:shadow-md`
                    }`}
                    style={{
                      animationDelay: `${index * 100}ms`,
                      animation: isLoaded
                        ? "slideInLeft 0.6s ease-out forwards"
                        : "none",
                    }}
                    onMouseEnter={() => setHoveredItem(item.name)}
                    onMouseLeave={() => setHoveredItem(null)}
                  >
                    {/* Background animation */}
                    <div
                      className={`absolute inset-0 ${theme.primary} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out origin-left`}
                    ></div>

                    {/* Icon */}
                    <div
                      className={`relative z-10 mr-4 transition-all duration-300 ${
                        isActive(item.href)
                          ? "text-white"
                          : `${theme.text} ${theme.hoverText}`
                      } ${
                        hoveredItem === item.name
                          ? "transform rotate-12 scale-110"
                          : ""
                      }`}
                    >
                      {item.icon}
                    </div>

                    {/* Text */}
                    <span className="relative z-10 transition-all duration-300">
                      {item.name}
                    </span>
                  </Link>
                ))}
              </nav>
            </div>

            {/* Management Section */}
            {employee ? (
              ""
            ) : (
              <div className="mb-8">
                <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4 px-3 text-left">
                  Gestión
                </h3>
                <nav className="space-y-2">
                  {managementItems.map((item, index) => (
                    <MenuItem
                      key={item.name}
                      item={item}
                      index={index + menuItems.length}
                      isActive={isActive(item)}
                      hoveredItem={hoveredItem}
                      setHoveredItem={setHoveredItem}
                      theme={theme}
                      onItemClick={handleItemClick}
                    />
                  ))}
                </nav>
              </div>
            )}
          </div>

          {/* Footer with logout */}
          <div className="px-4 py-4 border-t border-gray-200 bg-gray-50/50">
            <div
              className={`group flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-300 ease-in-out transform hover:scale-105 cursor-pointer text-gray-700 ${theme.hover} hover:text-white hover:shadow-md relative overflow-hidden`}
            >
              <div
                className={`absolute inset-0 ${theme.primary} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out origin-left`}
              ></div>
            </div>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <div className="transition-all duration-500 ease-in-out ml-72">
        <div className="p-6">{children}</div>
      </div>

      <style jsx>{`
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      <Modal showModal={showModal} setShowModal={setShowModal}>
        <ContentFormCompany user={user} />
      </Modal>
    </>
  );
}

// Componente para renderizar elementos del menú
function MenuItem({
  item,
  index,
  isActive,
  hoveredItem,
  setHoveredItem,
  theme,
  onItemClick,
}) {
  const baseClasses = `group flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-300 ease-in-out transform hover:scale-105 relative overflow-hidden ${
    isActive
      ? `${theme.primary} text-white shadow-lg scale-105`
      : `text-gray-700 ${theme.hover} hover:text-white hover:shadow-md`
  }`;

  const content = (
    <>
      {/* Background animation */}
      <div
        className={`absolute inset-0 ${theme.primary} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out origin-left`}
      ></div>

      {/* Icon */}
      <div
        className={`relative z-10 mr-4 transition-all duration-300 ${
          isActive ? "text-white" : `${theme.text} ${theme.hoverText}`
        } ${hoveredItem === item.name ? "transform rotate-12 scale-110" : ""}`}
      >
        {item.icon}
      </div>

      {/* Text */}
      <span className="relative z-10 transition-all duration-300">
        {item.name}
      </span>

      {/* Active indicator */}
      {isActive && (
        <div className="absolute right-2 w-2 h-2 bg-white rounded-full animate-pulse"></div>
      )}
    </>
  );

  const commonProps = {
    className: baseClasses,
    style: {
      animationDelay: `${index * 100}ms`,
      animation: "slideInLeft 0.6s ease-out forwards",
      width: "-webkit-fill-available",
    },
    onMouseEnter: () => setHoveredItem(item.name),
    onMouseLeave: () => setHoveredItem(null),
  };

  // Si es un link, usar Link de Next.js
  if (item.type === "link") {
    return (
      <Link to={item.href} {...commonProps}>
        {content}
      </Link>
    );
  }

  // Si es un button, usar button con onClick
  if (item.type === "button") {
    return (
      <button
        {...commonProps}
        onClick={() => onItemClick && onItemClick(item.onClick, item)}
      >
        {content}
      </button>
    );
  }

  return null;
}

export default Sidebar;
